import React from 'react';

function DeleteDialog({ onConfirm, onCancel }) {
  return (
    <>
      <div 
        className="dashboard__delete-overlay"
        onClick={onCancel}
      />
      <div className="dashboard__delete-popup">
        <div className="dashboard__delete-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
            <line x1="10" y1="11" x2="10" y2="17"/>
            <line x1="14" y1="11" x2="14" y2="17"/>
          </svg>
        </div>
        <h3 className="dashboard__delete-title">Delete Entry?</h3>
        <p className="dashboard__delete-message">
          This entry will be permanently removed. This action cannot be undone.
        </p>
        <div className="dashboard__delete-actions">
          <button 
            className="dashboard__delete-btn dashboard__delete-btn--cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            className="dashboard__delete-btn dashboard__delete-btn--confirm"
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </>
  );
}

export default DeleteDialog;
